module.exports = __webpack_public_path__ + "static/img/fling-tit.b68fe1fe.png";